<div class="flex min-h-screen items-center justify-center bg-[#050505] p-6 font-sans antialiased">

  <div class="group relative w-full max-w-md overflow-hidden rounded-[3rem] border border-[#333] bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] p-1 shadow-[0_50px_100px_-20px_rgba(0,0,0,1)] transition-all duration-700 hover:scale-[1.03]">

    <div class="absolute inset-0 translate-x-[-100%] bg-gradient-to-r from-transparent via-white/5 to-transparent transition-transform duration-1000 group-hover:translate-x-[100%]"></div>

    <div class="relative rounded-[2.8rem] bg-[#0c0c0c] p-10">

      <div class="mb-8 flex justify-center">
        <h1 class="text-[12px] font-black tracking-[0.6em] text-white/40 uppercase">
          VENTORA
        </h1>
      </div>

      <div class="flex flex-col items-center">
        <div class="relative mb-6">
          <div class="absolute inset-0 scale-150 animate-pulse bg-yellow-500/10 blur-3xl"></div>
          <div class="relative flex h-20 w-20 items-center justify-center rounded-2xl p-[1.5px] bg-gradient-to-tr from-[#6b4e2a] via-[#f9d976] to-[#b28451] shadow-2xl shadow-black">
            <div class="flex h-full w-full items-center justify-center rounded-[14px] bg-[#0c0c0c] relative overflow-hidden">
              <div class="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/brushed-alum.png')]"></div>
              <span class="relative text-4xl font-serif font-light italic text-transparent bg-clip-text bg-gradient-to-b from-[#f9d976] to-[#8a662d] drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
                V
              </span>
            </div>
          </div>
        </div>
        <span class="text-[9px] font-black tracking-[0.3em] text-[#b28451] uppercase text-center leading-relaxed">
          Handcrafted Precision <br> Tailored Exclusively for You
        </span>
      </div>

      <div class="mt-12 text-center">
        <p class="text-[10px] font-bold tracking-[0.2em] text-white/30 uppercase">Masterpiece</p>
        <h3 class="text-xl font-light text-white/95 mb-6 tracking-[0.05em]">
          @for(owner of ownerDetails?.items;track $index){
            {{owner?.name}} <br>
          }
        </h3>

        <p class="mb-1 text-[10px] font-bold tracking-[0.2em] text-white/30 uppercase border-t border-white/5 pt-6 italic">Specially Commissioned For</p>
        <h2 class="bg-gradient-to-b from-white via-white to-gray-400 bg-clip-text text-4xl font-light tracking-tight text-transparent">
          {{ownerDetails?.firstName | titlecase}} {{ownerDetails?.lastName | uppercase}}
        </h2>

        <div class="my-10 flex items-center justify-center gap-4">
          <div class="h-[0.5px] w-full bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
          <div class="h-1.5 w-1.5 rotate-45 border border-yellow-500/50 bg-[#0c0c0c]"></div>
          <div class="h-[0.5px] w-full bg-gradient-to-l from-transparent via-white/20 to-transparent"></div>
        </div>

        <div class="grid grid-cols-2 gap-8 text-left">
          <div>
            <p class="text-[9px] font-bold tracking-widest text-white/20 uppercase">Registry Date</p>
            <p class="text-sm font-medium text-white/80 tracking-widest" *ngIf="ownerDetails?.createdAt">
              {{ ownerDetails?.createdAt | date: 'dd MMMM yyyy' }}

            </p>
          </div>
          <div class="text-right">
            <p class="text-[9px] font-bold tracking-widest text-white/20 uppercase">Unique ID</p>
            <p class="text-sm font-mono text-[#b28451]">V-HCP-{{ ownerDetails?.orderConfId | slice: -3 }}</p>
          </div>
        </div>
      </div>

      <div class="mt-12 flex flex-col items-center border-t border-white/5 pt-6 space-y-3">

        <p class="text-[8px] text-white/20 uppercase tracking-[0.1em]">Designed & Assembled by Ventora Studio</p>
      </div>
    </div>
  </div>
</div>
